import React from 'react';
import Button from '../ui/Button';
import './Hero.css';

const Hero: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero section" id="hero">
      <div className="container">
        <div className="hero__content">
          <div className="hero__text">
            <p className="hero__tagline">See clearly. Decide boldly. Grow together.</p>
            <h1 className="hero__title heading-1">
              Where data, processes, and people's knowledge finally meet.
            </h1>
            <p className="hero__subtitle">
              Something is always stalling. The question is where.
            </p>
            <p className="hero__description">
              Furudio gives your whole organization one shared view, creating a coherent story 
              of where you're going, what's in the way, and who needs to do what next.
            </p>
            <p className="hero__description">
              A guided strategy process that makes dependencies visible, structured to capture the knowledge 
              that matters, and ensures everyone knows their role in getting there.
            </p>
            <p className="hero__cta-text">
              So decisions get made on the same reality.
            </p>
            <div className="hero__actions">
              <Button
                variant="primary"
                size="lg"
                onClick={scrollToContact}
              >
                Book a strategy conversation
              </Button>
            </div>
          </div>
          <div className="hero__visual">
            <img 
              src="/Dependency wheel – muokattu.png" 
              alt="Furudio Dependency Wheel showing interconnected departments and strategic goals" 
              className="hero__image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
